import { isAnalyticsEnabled } from './analytics-gate';

export const isLocalBuild = import.meta.env.DEV || import.meta.env.VITE_APP_ENV === 'e2e';

export const analyticsEnabled = isAnalyticsEnabled({
	appEnv: import.meta.env.VITE_APP_ENV,
	isDev: import.meta.env.DEV,
	key: import.meta.env.VITE_PUBLIC_POSTHOG_KEY ?? '',
	hostname: window.location.hostname,
});
